export default "__VITE_ASSET__BQQIUq0J__"